import type { HeadingProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { ColorField, SelectField, TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const LEVELS = ["1", "2", "3", "4", "5", "6"] as const;
const ALIGN = ["left", "center", "right"] as const;

export function HeadingInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as HeadingProps;

  return (
    <>
      <TextField
        label="Text"
        value={p.text}
        onChange={(v) => update(widget.id, { text: v })}
      />
      <SelectField
        label="Level"
        value={String(p.level) as (typeof LEVELS)[number]}
        options={LEVELS}
        onChange={(v) => update(widget.id, { level: Number(v) })}
      />
      <SelectField
        label="Align"
        value={p.align ?? "left"}
        options={ALIGN}
        onChange={(v) => update(widget.id, { align: v })}
      />
      <ColorField
        label="Color"
        value={p.color ?? "#111111"}
        onChange={(v) => update(widget.id, { color: v })}
      />
    </>
  );
}
